import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

import { userSubOrderAccessorGetStatus } from '../model/userSubOrderAccessor'

export const orderStatusAccessorEnrichSingleOrderStatus = (
  subOrders: UserSubOrderV2[] | UserOrderResponseWithFlagsSubOrdersInner[],
): void => {
  for (const [index, subOrder] of subOrders.entries()) {
    subOrder.status = userSubOrderAccessorGetStatus(subOrders, index)
  }
}
